(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  const insuranceCheckbox = document.querySelector(".insurance-checkbox input")

  if (!insuranceCheckbox || insuranceCheckbox.checked) {
    return
  }

  setTimeout(function() {
    insuranceCheckbox.checked = true
    insuranceCheckbox.dispatchEvent(new Event("change", { bubbles: true }))
  }, 2000)

  } catch(e) { console.error(e); }
})();
})();
